<template>
  <div class="notification">
      <span class="notification__text" v-html="notification.text"></span>
      <i @click="removeNotification" class="notification__close material-icons pointer">icon_close</i>
  </div>
</template>

<script>
export default {
  props: {
    notification: Object
  },
  methods: {
    removeNotification() {
      this.$store.dispatch('notifications_delete', this.notification.guid);
    }
  },
  created() {
    if (!this.notification.withAction) {
      setTimeout(() => {
        this.removeNotification();
      }, 10000);
    }
  }
};
</script>

<style lang="scss">
.notification {
  display: flex;
  align-items: center;
  width: fit-content;
  max-width: 400px;
  background: $orange;
  border-radius: 20px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
  padding: $margin-base;
  padding-right: $margin-tera;
  margin: $margin-milli 0;
  position: relative;
  color: #fff;

  &__text {
    color: #fff;
    font-weight: normal;

    span {
      margin-right: $margin-milli;
      //color: #202020;
      color:$white;
      @include font-settings(milli, base);
    }
  }

  &__close {
    position: absolute;
    right: $margin-base;
    color: #fff;
  }
}
</style>
